/* eslint-disable @typescript-eslint/no-explicit-any */
import useErrorStore from "@/store/confirmationStore";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "./ui/alert-dialog";
import { parseError } from "@/services/errorHandler";

function getErrorDialogMessage(error: any): React.ReactNode {
  const parsed = parseError(error);

  if (parsed.field) {
    return (
      <>
        <p className="font-semibold mb-4 text-md">{parsed.message}</p>
        <p className="mt-2 text-sm text-muted-foreground">
          <strong>Field:</strong> <span className="font-mono">{parsed.field}</span>
        </p>
      </>
    );
  }

  return parsed.message || "An unexpected error occurred.";
}


export function GlobalErrorDialog() {
  const { open, message, closeError } = useErrorStore();

  return (
    <AlertDialog open={open}>
      <AlertDialogContent className="max-w-lg">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-red-600">Error</AlertDialogTitle>
          <AlertDialogDescription
            className="max-h-60 overflow-y-auto whitespace-pre-wrap"
          >
            {getErrorDialogMessage(message)}
          </AlertDialogDescription>
        </AlertDialogHeader>

        {/* Footer stays visible even when content scrolls */}
        <AlertDialogFooter className="mt-4">
          <AlertDialogAction onClick={closeError} className="bg-primary cursor-pointer">OK</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
